module.exports = __webpack_public_path__ + "media/s2_v0.76765ba5.mp4";